export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0b';
  const units = ['b', 'kb', 'mb', 'gb', 'tb'];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, index);

  return `${size.toFixed(0)}${units[index]}`;
};
